import React, { useEffect } from 'react';
import './index.css';
import DatabaseGraph from './components/DatabaseGraph';

function SchemaVisualizer() {
  // Hide the utility buttons when this component mounts
  useEffect(() => {
    const buttonsContainer = document.querySelector('.container.mx-auto.py-8.text-center');
    if (buttonsContainer) {
      buttonsContainer.style.display = 'none';
    }
    
    // Restore the buttons when component unmounts
    return () => {
      if (buttonsContainer) {
        buttonsContainer.style.display = 'block';
      }
    };
  }, []);

  return (
    <section className="p-0 flex flex-col" style={{ minHeight: 'calc(100vh - 150px)', width: '100vw', maxWidth: '100vw' }}>
      <div className="w-full flex-grow flex flex-col mb-2" style={{ maxWidth: '100vw' }}>
        <h1 className="text-3xl font-heading font-bold text-center mb-1">ERP Schema Visualizer</h1>
        <p className="text-lg text-center mb-1 mx-auto">
          Visualize Epicor ERP database tables and their relationships. Find connections between multiple tables and explore the database schema.
        </p>
        
        <div className="bg-white rounded-lg shadow-md p-1 mb-1">
          <h2 className="text-xl font-heading font-bold mb-1">Instructions</h2>
          <ul className="list-disc pl-5 mb-1">
            <li>Click on a table to see its relationships</li>
            <li>Use the search box to find specific tables</li>
            <li>Adjust the node depth to see more or fewer related tables</li>
            <li>Use the view controls to customize your visualization</li>
            <li><a href="/contact" className="text-primary hover:underline">Feedback welcome!</a></li>
          </ul>
          
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mb-2">
            <ul className="list-disc pl-5 mb-0 text-sm text-gray-700">
              <li>The connections to Company aren't shown because they would create too many lines.</li>
              <li>Only joins defined within the Epicor framework are displayed.</li>
              <li>Watch our demo video: <a href="https://www.youtube.com/watch?v=9ETpJJKKLjY" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Database Graph Demo</a></li>
            </ul>
          </div>
        </div>
        
        <div className="flex-grow w-full" style={{ maxWidth: '100vw' }}>
          <DatabaseGraph />
        </div>
      </div>
    </section>
  );
}

export default SchemaVisualizer; 